import {register} from './../exports/theme-sections';
import parallaxImage from './../exports/parallaxImage';

register('double', parallaxImage);
